// components
import CommonActionModal from "../Common/CommonActionModal";
import CallsListModalInner from "./CallsListModalInner";

// icons
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';


class CallsListModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: LocalPhoneIcon,
            buttonIconOnly: this.props.buttonIconOnly,
            buttonColor: 'primary',
            ready: true,
            flat: this.props.flat,
        })
    }

    async beforeModalOpen(){
        let phone = this.props.phone
        if (this.props.componentObj){
            phone = this.props.componentObj.contact.primary_standard_phone
        }
        return {
            modalLabel: 'Список звонков',
            modalIcon: LocalPhoneIcon,
            mainComponent: CallsListModalInner,
            mainComponentProps: {
                phone: phone,
            },
        }
    }

}

export default CallsListModal
